export const buildCategoryTree = (itemCategories) => {
    const nodesById = new Map(
        itemCategories.map((itemCategory) => [itemCategory.itemCategoryId, {...itemCategory, children: []}])
    );

    const roots = [];

    nodesById.forEach((node) => {
        if (node.parentId && nodesById.has(node.parentId)) {
            nodesById.get(node.parentId).children.push(node);
        } else {
            roots.push(node);
        }
    });

    const sortByOrder = (nodes) => {
        nodes.sort((a, b) => a.order - b.order);
        nodes.forEach((node) => sortByOrder(node.children));
    };
    sortByOrder(roots);

    return roots;
};
